import { useState, useEffect } from 'react';
const useCountdown = targetDate => {
  const [remainingTime, setRemainingTime] = useState('');
  useEffect(() => {
    if (!targetDate) return;
    const calculateTimeLeft = () => {
      const now = new Date();
      const target = new Date(targetDate);
      const difference = target.getTime() - now.getTime();
      if (difference <= 0) {
        setRemainingTime('Deal expired');
        return;
      }
      const hours = Math.floor(difference / (1000 * 60 * 60));
      const minutes = Math.floor(difference % (1000 * 60 * 60) / (1000 * 60));
      const seconds = Math.floor(difference % (1000 * 60) / 1000);
      setRemainingTime(`Deal expires in ${hours}h ${minutes}m ${seconds}s`);
    };
    calculateTimeLeft();
    const interval = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(interval);
  }, [targetDate]);
  return remainingTime;
};
export default useCountdown;